import React from 'react';
import GamePanel from './GamePanelNew';
import '../../styles/fightCardV2.1.0/BaseFightCard.scss';

const BaseFightCard = ({
  fight: {
    sportLeague,
    makerName,
    makerTeam,
    makerTeamAcronym,
    makerTeamColor,
    makerOutcomePhrase,
    takerTeam,
    takerTeamAcronym,
    takerTeamColor,
    makerItems,
    startTime,
  },
  selectedTeam,
  tabComponent,
  bottomComponent,
  onClickCard,
}) => (
  <div
    className='base-fight-card'
    onClick={onClickCard}
    onKeyDown={e => e.key === 'Enter' && onClickCard()}
    role='button'
    tabIndex={0}>
    {tabComponent && <div className='tab'>{tabComponent}</div>}
    <div className='main'>
      <div className='center-row'>
        <div className='left-block'>
          <div className='outlined-text'>
            <span className='stroke'>{makerOutcomePhrase}</span>
            <span className='fill'>{makerOutcomePhrase}</span>
          </div>
          <p className='stakes-text'>
            {makerItems.map(item => (
              <React.Fragment key={item.menu_item_id}>
                {item.name} x{item?.quantity || item?.amount}
                <br />
              </React.Fragment>
            ))}
          </p>
        </div>
        <div className='right-block'>
          <GamePanel
            sport={sportLeague}
            leftTeam={takerTeam}
            rightTeam={makerTeam}
            leftTeamAcronym={takerTeamAcronym}
            rightTeamAcronym={makerTeamAcronym}
            selectedTagLabel='Confirm'
            unselectedTagLabel={makerName}
            leftColor={takerTeamColor}
            rightColor={makerTeamColor}
            startTime={startTime}
            teamSelected={selectedTeam}
            isSelected
            isFightCard
            short
          />
        </div>
      </div>
      {bottomComponent}
    </div>
  </div>
);

export default BaseFightCard;
